/* Plain JS: no libraries. Safe to initialize more than once. */
(function () {
  'use strict';
  function mount(root) {
    if (root.dataset.odjMounted) return;
    root.dataset.odjMounted = 'true';
    const steps = [...root.querySelectorAll('.odj__step')];
    const journey = root.querySelector('.odj__journey');
    const media = window.matchMedia('(prefers-reduced-motion: reduce)');
    let observer, frame = 0, highestProgress = 0;
    function updatePath() {
      frame = 0;
      const rect = journey.getBoundingClientRect();
      const span = Math.min(rect.height, window.innerHeight * .75);
      const progress = Math.max(0, Math.min(1, (window.innerHeight * .85 - rect.top) / span));
      highestProgress = Math.max(highestProgress, progress);
      root.style.setProperty('--odj-progress', highestProgress.toFixed(3));
    }
    function onScroll() { if (!frame) frame = requestAnimationFrame(updatePath); }
    function configureMotion() {
      observer?.disconnect();
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      root.classList.remove('odj--motion');
      root.style.setProperty('--odj-progress', '1');
      if (media.matches || !('IntersectionObserver' in window)) return;
      root.classList.add('odj--motion');
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('odj--visible');
            observer.unobserve(entry.target);
          }
        });
      }, {threshold: .12});
      steps.forEach(step => observer.observe(step));
      window.addEventListener('scroll', onScroll, {passive: true});
      window.addEventListener('resize', onScroll, {passive: true});
      updatePath();
    }
    configureMotion();
    media.addEventListener('change', configureMotion);

    const audio = root.querySelector('.odj__audio');
    const button = root.querySelector('.odj__play');
    const label = root.querySelector('.odj__play-label');
    const symbol = root.querySelector('.odj__play-symbol');
    const status = root.querySelector('.odj__status');
    if (!audio) {
      // Audio is handled by the React sample player; keep only the scroll animation here
      root.odjDestroy = () => {
        delete root.dataset.odjMounted;
        observer?.disconnect();
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
        media.removeEventListener('change', configureMotion);
        if (frame) cancelAnimationFrame(frame);
      };
      return;
    }
    let timer = 0, request = 0;
    const ac = new AbortController(); const sig = {signal: ac.signal};
    const source = root.dataset.sampleAudio.trim();
    function ui(playing) {
      root.classList.toggle('odj--playing', playing);
      button.setAttribute('aria-pressed', String(playing));
      button.setAttribute('aria-label', playing ? 'Stop sample call' : 'Play six-second sample call');
      label.textContent = playing ? 'Stop sample' : 'Hear sample · 6 sec';
      symbol.textContent = playing ? '■' : '▶';
    }
    function stop(message = '') {
      request++;
      clearTimeout(timer);
      audio.pause();
      if (audio.readyState) audio.currentTime = 0;
      ui(false);
      button.disabled = !source;
      status.textContent = message;
    }
    if (source) {
      audio.src = source;
      button.disabled = false;
      status.textContent = 'A short preview of the morning call';
    }
    button.addEventListener('click', async () => {
      if (!audio.paused) { stop(); return; }
      const token = ++request;
      // Pause other HTML audio/video players on this page; never autoplay.
      document.querySelectorAll('audio, video').forEach(other => {
        if (other !== audio && !other.paused) other.pause();
      });
      button.disabled = true;
      status.textContent = 'Loading sample…';
      try {
        if (audio.readyState) audio.currentTime = 0;
        await audio.play();
        if (token !== request) { audio.pause(); return; }
        button.disabled = false;
        status.textContent = '';
      } catch (err) {
        if (token !== request) return;
        // Retry once after reloading the file (first tap can fail while the browser fetches it)
        try { audio.load(); await audio.play(); if (token === request) { button.disabled = false; status.textContent = ''; } }
        catch (_) { if (token === request) stop('Could not play the sample. Please try again.'); }
      }
    }, sig);
    audio.addEventListener('playing', () => {
      ui(true);
      clearTimeout(timer);
      timer = setTimeout(() => stop('Preview finished'), Math.max(0, 6 - audio.currentTime) * 1000);
    }, sig);
    audio.addEventListener('timeupdate', () => { if (audio.currentTime >= 6) stop('Preview finished'); }, sig);
    audio.addEventListener('pause', () => { clearTimeout(timer); ui(false); }, sig);
    audio.addEventListener('ended', () => stop('Preview finished'), sig);
    audio.addEventListener('error', () => stop('Sample unavailable. Please try again later.'), sig);
    const onVisibility = () => { if (document.hidden) stop(); };
    document.addEventListener('visibilitychange', onVisibility);
    // Prevent overlap if another sample player starts later.
    const onOtherPlay = event => {
      if (event.target !== audio && !audio.paused) stop();
    };
    document.addEventListener('play', onOtherPlay, true);
    // SPA integrations may call the cleanup function before removing this section.
    root.odjDestroy = () => {
      delete root.dataset.odjMounted;
      stop(); ac.abort(); observer?.disconnect();
      document.removeEventListener('visibilitychange', onVisibility);
      document.removeEventListener('play', onOtherPlay, true);
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      media.removeEventListener('change', configureMotion);
      if (frame) cancelAnimationFrame(frame);
    };
  }
  window.initOnDoseJourney = function () {
    document.querySelectorAll('.odj').forEach(mount);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.initOnDoseJourney, {once:true});
  else window.initOnDoseJourney();
})();
